<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameConfirmResult.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameConfirmResult.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('gameConfirmResult.search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
          <a-drawer
            :title="$t('filter')"
            placement="right"
            :closable="false"
            :visible="visible"
            @close="visible = false"
            :zIndex="1020"
            width="300px"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <a-range-picker
                    format="DD-MM-YYYY"
                    :defaultValue="rangeDate"
                    :defaultPickerValue="rangeDate"
                    @change="dateRangeChange"
                  >
                    <template slot="renderExtraFooter"></template>
                  </a-range-picker>
                </div>
              </div>
            </div>
          </a-drawer>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.game_set.game_set_name }}</td>
          <td>{{ record.result_date }}</td>
          <td>
            <span class="ts-font-semibold ts-text-heading-color">{{
              record.result_number
            }}</span>
          </td>
          <td class="text-center">
            <span
              class="ts-font-semibold ts-text-maincolor"
              v-if="record.is_released"
            >
              <i class="fas fa-check"></i>
            </span>
          </td>
          <td class="text-center">
            <a href="#" 
              v-tooltip="$t('gameConfirmResult.link')"
              @click.prevent="addLink(record)"
            >
              <i class="fas fa-link"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- show form create -->
    <a-modal
      v-if="show_form_confirm"
      v-model="show_form_confirm"
      :title="$t('create')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      width="1100px"
      @cancel="onClose"
    >
      <ConfirmForm @fetchData="fetchData" />
    </a-modal>
    <!-- upload link -->
    <a-modal
      v-if="show_input_link"
      v-model="show_input_link"
      :title="$t('update')"
      centered
      :zIndex="1020"
      :mask-closable="false"
      width="400px"
      :cancelText="$t('cancel')"
      :okText="$t('save')"
      :confirmLoading="waiting"
      @cancel="() => show_input_link = false"
      @ok="onUpldateLink"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required ts-text-xs">{{ $t('gameConfirmResult.link') }}</label>
            <input type="text" class="form-control" v-model="model.live_url">
            <div class="validate ts-text-xs" v-if="errors.has('live_url')">
              {{ errors.first('live_url') }}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import ConfirmForm from './components/comfirm_form'
import moment from 'moment'

export default {
  name: 'gameConfirmResult',
  components: {
    ConfirmForm
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      visible: false,
      show_form_confirm: false,
      show_input_link: false,
      rangeDate: [moment(), moment().add(1, 'Day')],
      model: {
        result_id: null,
	      live_url: null,
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/gameConfirmResult', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.gameConfirmResult.search
      },
      set(newValue) {
        this.$store.commit(
          'administrator/gameConfirmResult/SET_SEARCH',
          newValue
        )
        this.$store.commit('administrator/gameConfirmResult/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('gameConfirmResult.gameSet') },
        { name: this.$t('gameConfirmResult.resultDate') },
        { name: this.$t('gameConfirmResult.result') },
        {
          name: this.$t('gameConfirmResult.release'),
          style: 'text-align:center; width:10px'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    addNew() {
      this.show_form_confirm = true
    },
    onClose() {
      this.show_form_confirm = false
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/gameConfirmResult/fetch', { ...attributes })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'administrator/gameConfirmResult/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'administrator/gameConfirmResult/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    addLink(record){
      this.model.result_id = record.result_id
      this.model.live_url = record.live_url ? 'https://www.youtube.com/watch?v=' + record.live_url : null
      this.show_input_link = true
    },
    onUpldateLink(){
      this.errors = new Errors()
      this.waiting = true
      this.$store.dispatch('administrator/gameConfirmResult/update', {
        id: this.model.result_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
          this.show_input_link = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameConfirmResult/RESET_STATE')
    next()
  }
}
</script>
